<div class="libraryHeader">
  <div class="pageHeader"><h1></h1></div>
  <input id="searchInput" class="searchBar" type="search" placeholder="Rechercher dans cette bibliothèque..." />
</div>
<p class="hint searchEmpty hide">Aucun résultat.</p>
<div id="grid" class="grid"><p class="hint"><span class="spinner"></span>Chargement...</p></div>
